const initialState = {
  data: [],
  totalCount: 0,
  currentPage: 0,
  pageSize: 15,
  loading: false,
  isError: false,
};

export function blacklistedContactsReducer(state = initialState, action) {
  switch (action.type) {

    case "FETCH_BLACKLISTED_CONTACTS_REQUEST":
      return { ...state, loading: true, isError: false };
    
      case "UPDATE_BLACKLIST_LIST_STATE":
        return {
          ...state,
          ...action.payload,
        };

    case "FETCH_BLACKLISTED_CONTACTS_SUCCESS":
      return {
        ...state,
        data: action.payload.data,
        totalCount: action.payload.totalCount,
        currentPage: action.payload.currentPage,
        pageSize: action.payload.pageSize,
        loading: false,
        isError: false,
        filtered: action.payload.filtered || [],
      };

    case "FETCH_BLACKLISTED_CONTACTS_FAILURE":
      return { ...state, loading: false, isError: true };

    case "RESET_BLACKLIST_ERROR":
      return { ...state, isError: false };

    default:
      return state;
  }
}
